import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  SelectPixelsTocErrorStyled,
  SelectPixelsTocErrorText,
  SelectPixelsTocErrorUrl,
} from './SelectPixelsTocError.styled'

type SelectPixelsTocErrorProps = {
  url: string
}
export const SelectPixelsTocError = ({ url }: SelectPixelsTocErrorProps) => {
  const { t } = useTranslation('PMPlatforms')
  return (
    <SelectPixelsTocErrorStyled>
      <SelectPixelsTocErrorText>{t('meta-connection-wizard.toc-error')}</SelectPixelsTocErrorText>
      <SelectPixelsTocErrorUrl target={'_blank'} href={url}>
        {t('meta-connection-wizard.this-link')}
      </SelectPixelsTocErrorUrl>
    </SelectPixelsTocErrorStyled>
  )
}
